import type transform from '../to/events';

export default (events: ReturnType<typeof transform>) => {
  if (events.length != new Set(events.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Events) Events array have two or more events with the same ID');

  return events
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Events) Event id is undefined');

      // backwards compatibility for file upload: use duration if preferredDuration does not exist
      if (x.duration) x.preferredDuration ??= x.duration;

      return { ...x };
    });
};
